import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HELPER_TEXT_CONSTS = {
  TEXT: "Can't find your location?",
  LINK: {
    TEXT: 'View our coverage areas.',
    URL: '/sitemap',
  },
};

const StyledParagraph = styled.p`
  margin: 0;
`;

const HelperText = () => {
  return (
    <StyledParagraph>
      {HELPER_TEXT_CONSTS.TEXT}{' '}
      <Link to={HELPER_TEXT_CONSTS.LINK.URL}>
        {HELPER_TEXT_CONSTS.LINK.TEXT}
      </Link>
    </StyledParagraph>
  );
};

export default HelperText;
